<template>
  <div id="box" class="fb-reply-page">
    <historyTag :historyArr="historyArr"></historyTag>

    <div id="mainBox" class="body fb-main">
      <div class="fb-toolbar">
        <el-input
          v-model="searchNickName"
          clearable
          placeholder="客户昵称"
          style="width: 200px"
          size="small"
          @keyup.enter.native="searchFn"
        />
        <el-input
          v-model="searchVle"
          clearable
          placeholder="反馈内容"
          style="width: 260px"
          size="small"
          @keyup.enter.native="searchFn"
        />
        <el-button type="success" size="small" @click="searchFn">搜索</el-button>
      </div>

      <div class="fb-split">
        <el-card shadow="never" class="fb-list-card">
          <div v-loading="listLoading" class="fb-list-inner">
            <div class="fb-table-wrap">
              <el-table
                ref="listTable"
                :data="tableData"
                border
                highlight-current-row
                :max-height="listTableMaxHeight"
                style="width: 100%"
                @current-change="onCurrentRowChange"
              >
                <el-table-column
                  type="index"
                  label="序号"
                  width="56"
                  align="center"
                  :index="tableIndexFn"
                />
              <el-table-column prop="id" label="id" width="64" align="center" />
              <el-table-column label="用户" min-width="88" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ scope.row.user ? scope.row.user.nickName : "-" }}
                </template>
              </el-table-column>
              <el-table-column prop="depict" label="意见反馈" min-width="140" show-overflow-tooltip />
              <el-table-column label="最近一条(聊天记录)" min-width="130" align="left" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.row.lastMessagePreview != null && scope.row.lastMessagePreview !== ''">
                    <el-tag
                      class="fb-last-sender-tag"
                      :type="lastMsgSenderTagType(scope.row.lastMessageSenderType)"
                      size="mini"
                    >
                      {{ lastMsgSenderLabel(scope.row.lastMessageSenderType) }}
                    </el-tag>
                    {{ scope.row.lastMessagePreview }}
                  </span>
                  <span v-else class="fb-last-empty">—</span>
                </template>
              </el-table-column>
              <el-table-column label="更新时间" width="152" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ formatMsgTime(scope.row.lastMessageTime || scope.row.createTime) }}
                </template>
              </el-table-column>
              </el-table>
            </div>
            <div class="page_box">
              <el-pagination
                :current-page.sync="currentPage"
                :page-size="pageSize"
                layout="total, prev, pager, next, jumper"
                :total="tableTotal"
                @current-change="changePage"
              />
            </div>
            <div class="fb-list-fill" aria-hidden="true" />
          </div>
        </el-card>

        <el-card shadow="never" class="fb-chat-card">
          <div v-if="!selectedRow" class="fb-chat-empty">请从左侧选择一条反馈</div>
          <template v-else>
            <div class="fb-chat-body">
              <div class="fb-chat-head">
                <span class="fb-chat-title">反馈 #{{ selectedRow.id }}</span>
                <span v-if="selectedRow.user" class="fb-chat-sub">{{ selectedRow.user.nickName }}</span>
              </div>
              <div class="fb-chat-depict">
                <div class="fb-chat-depict-label">反馈意见</div>
                <div class="fb-chat-depict-text">{{ selectedRow.depict || "—" }}</div>
              </div>
              <div ref="msgScroll" v-loading="msgLoading" class="fb-msg-scroll">
                <div
                  v-for="m in messages"
                  :key="m.id"
                  :class="['fb-msg-row', isPlatformMsg(m) ? 'is-platform' : 'is-user']"
                >
                  <div class="fb-msg-meta">
                    {{ msgSenderDisplay(m) }}
                    · {{ formatMsgTime(m.createTime) }}
                  </div>
                  <div class="fb-msg-bubble">{{ m.content }}</div>
                </div>
                <div v-if="!msgLoading && messages.length === 0" class="fb-msg-empty">暂无消息</div>
              </div>
              <div class="fb-reply-bar">
                <el-input
                  v-model="replyText"
                  type="textarea"
                  :rows="5"
                  maxlength="2000"
                  show-word-limit
                  class="fb-reply-textarea"
                  placeholder="输入回复内容；Ctrl+Enter 发送，Enter 换行"
                  @keydown.native="onReplyKeydown"
                />
                <el-button
                  type="primary"
                  size="small"
                  :loading="sendLoading"
                  :disabled="!replyText || !replyText.trim()"
                  @click="sendReply"
                >
                  发送
                </el-button>
              </div>
            </div>
          </template>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import { returnTime } from "@/util/utils";

const SENDER_PLATFORM = 2;

export default {
  name: "FeedbackReply",
  data() {
    return {
      historyArr: ["反馈意见", "意见处理"],
      searchNickName: "",
      searchVle: "",
      tableData: [],
      pageSize: 20,
      currentPage: 1,
      tableTotal: 0,
      listLoading: false,
      selectedRow: null,
      messages: [],
      msgLoading: false,
      replyText: "",
      sendLoading: false,
      listLayoutH: typeof window !== "undefined" ? window.innerHeight : 800,
    };
  },
  computed: {
    /** 表格按可视区域限制高度并内部滚动，避免 height=100% 在 tbody 下出现大块空白 */
    listTableMaxHeight() {
      return Math.max(220, this.listLayoutH - 278);
    },
  },
  mounted() {
    this.selListFn(1);
    this._fbOnResize = () => {
      this.listLayoutH = window.innerHeight;
    };
    window.addEventListener("resize", this._fbOnResize);
  },
  beforeDestroy() {
    if (this._fbOnResize) {
      window.removeEventListener("resize", this._fbOnResize);
    }
  },
  methods: {
    formatMsgTime(t) {
      if (!t) return "-";
      try {
        return returnTime(new Date(t), "-", "s");
      } catch (e) {
        return String(t);
      }
    },
    isPlatformMsg(m) {
      return m && Number(m.senderType) === SENDER_PLATFORM;
    },
    lastMsgSenderLabel(senderType) {
      const t = Number(senderType);
      if (t === SENDER_PLATFORM) return "平台";
      if (t === 1) return "用户";
      return "—";
    },
    lastMsgSenderTagType(senderType) {
      return Number(senderType) === SENDER_PLATFORM ? "primary" : "info";
    },
    /** 列表序号（随分页递增） */
    tableIndexFn(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1;
    },
    /** 会话里非平台消息展示客户昵称 */
    msgSenderDisplay(m) {
      if (this.isPlatformMsg(m)) return "平台";
      const name = this.selectedRow && this.selectedRow.user ? this.selectedRow.user.nickName : "";
      return name || "客户";
    },
    searchFn() {
      this.resetChatPanel();
      this.currentPage = 1;
      this.selListFn(1);
    },
    /** 搜索或换条件时清空右侧会话，避免仍显示上次选中内容 */
    resetChatPanel() {
      this.selectedRow = null;
      this.messages = [];
      this.replyText = "";
      this.msgLoading = false;
      this.$nextTick(() => {
        if (this.$refs.listTable) {
          this.$refs.listTable.setCurrentRow(null);
        }
      });
    },
    changePage(p) {
      this.selListFn(p);
    },
    selListFn(page) {
      this.listLoading = true;
      const obj = {
        page,
        size: this.pageSize,
      };
      if (this.searchNickName && this.searchNickName.trim()) {
        obj.nickName = this.searchNickName.trim();
      }
      if (this.searchVle) {
        obj.depict = this.searchVle;
      }
      this.$https(this.$api.api.selFeedback, obj, "POST")
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.tableData = res.data.data || [];
            this.tableTotal = res.data.size || 0;
            this.$nextTick(() => {
              if (this.selectedRow) {
                const hit = this.tableData.find((r) => r.id === this.selectedRow.id);
                if (hit && this.$refs.listTable) {
                  this.$refs.listTable.setCurrentRow(hit);
                } else if (!hit) {
                  this.selectedRow = null;
                  this.messages = [];
                }
              }
            });
          } else {
            this.tableData = [];
            this.tableTotal = 0;
          }
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    onCurrentRowChange(row) {
      if (!row) return;
      this.selectedRow = row;
      this.loadMessages(row.id);
    },
    loadMessages(opinionId) {
      if (!opinionId) return;
      this.msgLoading = true;
      this.messages = [];
      this.$https(
        this.$api.api.selOpinionMessageList,
        {
          opinionId,
          page: 1,
          size: 500,
        },
        "POST"
      )
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.messages = res.data.data || [];
            this.$nextTick(() => this.scrollMsgToBottom());
          } else {
            this.messages = [];
            this.$message.error((res.data && res.data.msg) || "加载消息失败");
          }
        })
        .finally(() => {
          this.msgLoading = false;
        });
    },
    scrollMsgToBottom() {
      const el = this.$refs.msgScroll;
      if (el) {
        el.scrollTop = el.scrollHeight;
      }
    },
    onReplyKeydown(e) {
      if (e.key === "Enter" && e.ctrlKey) {
        e.preventDefault();
        this.sendReply();
      }
    },
    sendReply() {
      const text = (this.replyText || "").trim();
      if (!text || !this.selectedRow) return;
      this.sendLoading = true;
      this.$https(
        this.$api.api.addOpinionMessage,
        {
          opinionId: this.selectedRow.id,
          content: text,
          senderType: SENDER_PLATFORM,
          senderId: "platform",
        },
        "POST"
      )
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.replyText = "";
            this.loadMessages(this.selectedRow.id);
            this.selListFn(this.currentPage);
            this.$message.success((res.data && res.data.msg) || "发送成功");
          } else {
            this.$message.error((res.data && res.data.msg) || "发送失败");
          }
        })
        .finally(() => {
          this.sendLoading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.fb-reply-page {
  width: 100%;
  min-height: calc(100vh - 48px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.body.fb-main {
  flex: 1;
  min-height: 0;
  margin-top: 12px;
  display: flex;
  flex-direction: column;
}
.fb-toolbar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}
.fb-split {
  flex: 1;
  min-height: 0;
  display: flex;
  gap: 12px;
  align-items: stretch;
}
.fb-list-card {
  flex: 0 0 58%;
  min-width: 400px;
  min-height: 0;
  display: flex;
  flex-direction: column;
  /deep/ .el-card__body {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 14px;
    height: 100%;
    box-sizing: border-box;
  }
}
.fb-table-wrap {
  flex: 0 0 auto;
  width: 100%;
  min-width: 0;
}
.fb-list-fill {
  flex: 1;
  min-height: 0;
}
.fb-chat-card {
  flex: 1;
  min-width: 0;
  max-width: 42%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  /deep/ .el-card__body {
    flex: 1;
    min-height: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: 100%;
    box-sizing: border-box;
  }
}
.fb-chat-body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.fb-last-empty {
  color: #c0c4cc;
}
.fb-last-sender-tag {
  margin-right: 6px;
  vertical-align: middle;
}
.fb-list-inner {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.fb-chat-empty {
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
}
.fb-chat-head {
  padding: 6px 10px;
  border-bottom: 1px solid #ebeef5;
  .fb-chat-title {
    font-weight: 600;
    font-size: 14px;
    margin-right: 10px;
  }
  .fb-chat-sub {
    color: #606266;
    font-size: 12px;
  }
}
.fb-chat-depict {
  padding: 6px 10px;
  border-bottom: 1px solid #ebeef5;
  background: #fafafa;
  flex-shrink: 0;
  max-height: 72px;
  overflow-y: auto;
}
.fb-chat-depict-label {
  font-size: 11px;
  color: #909399;
  margin-bottom: 4px;
}
.fb-chat-depict-text {
  font-size: 13px;
  color: #303133;
  line-height: 1.5;
  word-break: break-word;
  white-space: pre-wrap;
}
/* 聊天记录区固定高度，超出部分内部滚动 */
.fb-msg-scroll {
  flex: 0 0 auto;
  width: 100%;
  height: 490px;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 6px 8px;
  background: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
  box-sizing: border-box;
}
.fb-msg-row {
  margin-bottom: 10px;
  max-width: 92%;
}
.fb-msg-row.is-user {
  margin-right: auto;
}
.fb-msg-row.is-platform {
  margin-left: auto;
  text-align: right;
}
.fb-msg-meta {
  font-size: 11px;
  color: #909399;
  margin-bottom: 3px;
}
.fb-msg-bubble {
  display: inline-block;
  text-align: left;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 13px;
  line-height: 1.45;
  word-break: break-word;
  white-space: pre-wrap;
}
.is-user .fb-msg-bubble {
  background: #fff;
  border: 1px solid #e4e7ed;
}
.is-platform .fb-msg-bubble {
  background: #ecf5ff;
  border: 1px solid #d9ecff;
}
.fb-msg-empty {
  text-align: center;
  color: #909399;
  padding: 16px;
  font-size: 13px;
}
.fb-reply-bar {
  flex-shrink: 0;
  padding: 8px 12px;
  border-top: none;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 8px;
  /deep/ .fb-reply-textarea .el-textarea__inner {
    resize: vertical;
    min-height: 100px;
    line-height: 1.5;
    font-size: 13px;
  }
}
.page_box {
  flex-shrink: 0;
  margin-top: 0;
  padding-top: 8px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/feedback/reply.vue